export default "__VITE_ASSET__CLYDtCdO__"